import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Nav } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';

export class NavMenu extends Component {
  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    console.log(window.location);
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
          <Container className="topcont">
            <NavbarBrand className='logo' tag={Link} to="/"></NavbarBrand>
                <div style={{flex: "auto"}}></div>
                <NavItem className='nav'>
                  <NavLink tag={Link} className={`text-dark ${window.location.pathname.startsWith("/booking")?"react-calendar__tile--active":"btn-book"}`} to="/booking" onClick={() => this.setState({collapsed: true})}>Бронирование</NavLink>
                </NavItem>
                <LoginMenu type="loginimages">
                </LoginMenu>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <Nav className="navbar-nav flex-grow ml-auto">
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/calendar" onClick={() => this.setState({collapsed: true})}>Календарь</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/configcompany" onClick={() => this.setState({collapsed: true})}>Компания</NavLink>
                </NavItem>
                <LoginMenu type="logintext">
                </LoginMenu>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
